import React from "react";
import { FiCheckCircle, FiPauseCircle, FiRefreshCw } from "react-icons/fi";
import { formatWithoutDecimal } from "../../utils/formatWithoutDecimal";
import { useDashboardValuePrivacy } from "../../hooks/useDashboardValuePrivacy";
import PrivacyBlur from "../PrivacyBlur";

const Orders = ({ className = "", ordersData }) => {
  const { valuesHidden } = useDashboardValuePrivacy();
  const performanceItems = [
    {
      title: `${formatWithoutDecimal(ordersData?.in_progress ?? 0)} orders`,
      subtitle: "In-Progress",
      bg: "#DBEAFE",
      color: "#2563EB",
      icon: FiRefreshCw,
    },
    {
      title: `${formatWithoutDecimal(ordersData?.pending ?? 0)} orders`,
      subtitle: "Pending",
      bg: "#FEE2E2",
      color: "#DC2626",
      icon: FiPauseCircle,
    },
    {
      title: `${formatWithoutDecimal(ordersData?.ready_for_delivery ?? 0)} orders`,
      subtitle: "Ready for Delivery",
      bg: "#EDE9FE",
      color: "#7C3AED",
      icon: FiCheckCircle,
    },
  ];
  return (
    <div className={`col-lg-3 col-md-5 col-12 ${className}`.trim()}>
      <div
        className="card shadow-none border-0"
        style={{
          minHeight: "275px",
          borderRadius: "18px",
          background: "#FFFFFF",
          border: "1px solid #E2E8F0",
        }}
      >
        <div className="card-body px-4 pt-4 pb-3">
          <h5
            className="mb-1"
            style={{ color: "#0F172A", fontSize: "1.05rem", fontWeight: 700 }}
          >
            Orders
          </h5>

          <div className="d-flex flex-column gap-3 mt-4">
            {performanceItems.map((item) => {
              const StatusIcon = item.icon;
              return (
                <div
                  key={item.subtitle}
                  className="d-flex align-items-center gap-3"
                >
                  <span
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      width: 42,
                      height: 50,
                      borderRadius: "12px",
                      background: item.bg,
                      color: item.color,
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    <StatusIcon size={18} />
                  </span>
                  <div>
                    <h6
                      className="mb-0"
                      style={{
                        color: "#0F172A",
                        fontSize: "0.95rem",
                        fontWeight: 600,
                      }}
                    >
                      <PrivacyBlur hidden={valuesHidden}>
                        {item.title}
                      </PrivacyBlur>
                    </h6>
                    <span style={{ color: "#64748B", fontSize: "0.82rem" }}>
                      {item.subtitle}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;
